<template>
  <div class="statistic">
    <div class="statistic__head">
      <div class="statistic__head-info">
        <h3 class="statistic__title">Statistics</h3>
        <p class="statistic__desc">Some data from your ads campaign</p>
      </div>
      <div class="statistic__head-controls">
        <button class="button button--small button--service statistic__head-controls-item"><i class="fa fa-download button__icon"></i> Export</button>
        <button class="button button--small button--service statistic__head-controls-item"><i class="fa fa-print button__icon"></i> Print</button>
      </div>
    </div>
    <div class="statistic__body">
      <div class="table">
        <div class="table__body">
          <b-table
            striped
            hover
            :items="items"
            :fields="fields"
            class="table__main"
            thead-tr-class="table__row"
          >
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const items = [
  {DATE: '', SPEND: '', IMPRESSIONS: '', CONVERSIONS: '', 'CPC/CPV': '', CONVERSIONS2: '', 'CONVERSION %': ''}
]
export default {
  name: 'Statistics',
  data () {
    return {
      items: items,
      fields: [
        {key: 'DATE', label: 'DATE', thClass: 'table__head'},
        {key: 'SPEND', label: 'SPEND', thClass: 'table__head'},
        {key: 'IMPRESSIONS', label: 'IMPRESSIONS', thClass: 'table__head'},
        {key: 'CONVERSIONS', label: 'CONVERSIONS', thClass: 'table__head'},
        {key: 'CPC/CPV', label: 'CPC/CPV', thClass: 'table__head'},
        {key: 'CONVERSIONS2', label: 'CONVERSIONS2', thClass: 'table__head'},
        {key: 'CONVERSIONS3', label: 'CONVERSIONS%', thClass: 'table__head'}
      ]
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/advertiser/plugins/statistics.vue